export let localStorages = {
  get: function(key) {
    var value = localStorage.getItem(key);
      if (value && value != 'undefined') {
      try {
        var value_json = JSON.parse(value);
        return value_json;
      } catch(e) {
        return value;
      }
    } else {
      return false;
    }
  },
  set: function(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  remove: function(key) {
    localStorage.removeItem(key);
  },
  clear: function() {
    localStorage.clear();
  },
  removeAll:function (uid,roomId) {
      if(this.get(`particitantInfo_${uid}`)){this.remove(`particitantInfo_${uid}`)};
      if(this.get(`setInfo_${uid}`)){this.remove(`setInfo_${uid}`)};
      if(this.get(`roomId_${uid}`)){this.remove(`roomId_${uid}`)};
      if(this.get(`token_${uid}`)){this.remove(`token_${uid}`)};
      if(this.get(`sessionToken_${uid}`)){this.remove(`sessionToken_${uid}`)};
      if(this.get(`mixInfos_${uid}`)){this.remove(`mixInfos_${uid}`)};
      if(this.get(`loginInfo_${uid}`)){this.remove(`loginInfo_${uid}`)};
      if(this.get(`inviteList_${uid}${roomId}`)){this.remove(`inviteList_${uid}`)};
      if(this.get(`participantList_${uid}`)){this.remove(`participantList_${uid}`)};
      if(this.get(`firstJoin_${uid}`)){this.remove(`firstJoin_${uid}`)};
  }
};

